// ----------------------------------------------------------------------
// (c) Copyright 2020, Dark Star Systems, Inc.  All rights reserved.
// This file may contain proprietary and confidential information.
// DO NOT COPY or distribute in any form without prior written consent.
// ----------------------------------------------------------------------

import moment from 'moment'
import {TimestampClass} from '@horizon/common/fb-types'

type AnyTimestamp = {_seconds: number; _nanoseconds: number}|{seconds: number; nanoseconds: number}

/** Convert a Firestore timestamp to a moment.
    This handles a timestamp with "_seconds" as well as the usual "seconds"
    because I've seen both for some reason. */
export function timestampToMoment(timestamp: AnyTimestamp) {
  const ts = ('seconds' in timestamp) ?
    new (TimestampClass())(timestamp.seconds, timestamp.nanoseconds) :
    new (TimestampClass())(timestamp._seconds, timestamp._nanoseconds)
  const date = ts.toDate()
  return moment(date)
}

/** relative time string from a timestamp */
export function timestampRel(timestamp: AnyTimestamp) {
  return timestampToMoment(timestamp).fromNow()
}

export function nsecToSecString(nsec: bigint) {
  const sec = nsec / BigInt(1e9)
  const nsecRemainder = (nsec - sec * BigInt(1e9))
  const msec = nsecRemainder / BigInt(1e6)
  const secAsDecimal = Number(sec) + Number(msec) / 1000
  if (sec > 0)
    return secAsDecimal.toFixed(3) + ' sec'
  else
    return msec + ' ms'
}

export function elapsedTimeString(startTime: bigint, endTime: bigint) {
  return nsecToSecString(endTime - startTime)
}
